import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { DataPartograf, CatatanPersalinan, Kala4Monitoring } from "@/types/partograf";
import SvcPartograf from "@/services/Partograf";

@Module({ dynamic: true, namespaced: true, store, name: "partograf" })
class Partograf extends VuexModule {
  partograf: DataPartograf = null;
  loading = false;

  @Mutation
  SET_PARTOGRAF(partograf: DataPartograf) {
    this.partograf = partograf;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async getPartografByReg(payload): Promise<void> {
    const reg = payload && typeof payload === "object" ? payload.reg : payload;
    const silent = !!(payload && typeof payload === "object" && payload.silent);

    if (!silent) this.SET_PARTOGRAF(null);
    this.SET_LOADING(true);
    try {
      const dataPartograf = await SvcPartograf.getByReg(reg);
      this.SET_PARTOGRAF(dataPartograf.data ? dataPartograf.data : null);
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action({ rawError: true })
  async ensurePartograf(header: any): Promise<number | string | null> {
    if (this.partograf && this.partograf['id']) return this.partograf['id'];

    try {
      await SvcPartograf.post({ ...header, partograf: [] });
    } catch {
      return null;
    }

    await this.getPartografByReg({ reg: header.register_id, silent: true });

    return this.partograf && this.partograf['id'] ? this.partograf['id'] : null;
  }

  @Action({ rawError: true })
  async deleteObservasi(payload: {
    id: number | string;
    index: number;
    reg: number | string;
  }): Promise<any> {
    const res = await SvcPartograf.deleteObservasi(payload.id, payload.index);
    if (res && res.data && res.data.status === 1) {
      await this.getPartografByReg({ reg: payload.reg, silent: true });
    }
    return res;
  }

  @Action({ rawError: true })
  async saveCatatanPersalinan(payload: {
    id: number | string;
    catatan_persalinan: CatatanPersalinan;
    kala4_monitoring: Kala4Monitoring;
  }): Promise<any> {
    const res = await SvcPartograf.updateCatatanPersalinan(payload.id, {
      catatan_persalinan: payload.catatan_persalinan,
      kala4_monitoring: payload.kala4_monitoring
    });
    if (res && res.data && res.data.status === 1) {
      if (this.partograf && this.partograf['register_id']) {
        await this.getPartografByReg(this.partograf['register_id']);
      }
    }
    return res;
  }

  @Action({ rawError: true })
  async signPartograf(payload: { id: number | string; password: string }): Promise<any> {
    const res = await SvcPartograf.sign(payload.id, payload.password);
    if (res && res.data && res.data.status === 1) {
      if (this.partograf && this.partograf['register_id']) {
        await this.getPartografByReg(this.partograf['register_id']);
      }
    }
    return res;
  }
}

export default getModule(Partograf);
